<template>
  <div>
    <v-radio-group v-model="type" inline class="mb-4">
      <v-radio label="Користувач" value="user" />
      <v-radio label="Підрозділ" value="department" />
    </v-radio-group>

    <b-autocomplete
      v-if="type === 'user'"
      v-model="credentials.userId"
      :items="$directory.get('userList')"
      :loading="$loading.isLoading('userList')"
      :item-title="getPersonName"
      item-value="id"
      placeholder="Оберіть користувача"
      :error-messages="getErrorMessages(v$.userId)" />

    <b-autocomplete
      v-if="type === 'department'"
      v-model="credentials.departmentId"
      :items="$directory.get('internalDepartments')"
      :loading="$loading.isLoading('internalDepartments')"
      item-title="name"
      item-value="id"
      placeholder="Оберіть підрозділ"
      :error-messages="getErrorMessages(v$.departmentId)" />
  </div>
</template>

<script lang="ts">
import { PropType, reactive, ref, watch } from 'vue'
import { Dialog } from '@/dialog'
import { fillDirectory } from '@/directory'
import { useVuelidate } from '@vuelidate/core'
import { requiredIf } from '@vuelidate/validators'
import { getPersonName, getErrorMessages } from 'best-modules/utils'
import { docTypeAccessCreate } from '@/requests/documentType'

export default {
  name: 'DocTypeAccess',
  props: {
    dialog: {
      type: Object as PropType<Dialog>,
      required: true,
    },
  },
  methods: { getPersonName, getErrorMessages },
  setup(props) {
    fillDirectory('userList')
    fillDirectory('internalDepartments')

    const type = ref<'user' | 'department'>('user')
    const credentials = reactive({ userId: null, departmentId: null })

    watch(type, () => {
      credentials.userId = null
      credentials.departmentId = null
    })

    const rules = {
      userId: {
        required: requiredIf(() => type.value === 'user'),
      },
      departmentId: {
        required: requiredIf(() => type.value === 'department'),
      },
    }

    const v$ = useVuelidate(rules, credentials)

    const submit = () => {
      const payload =
        type.value === 'user'
          ? { userId: credentials.userId }
          : { departmentId: credentials.departmentId }

      return docTypeAccessCreate(props.dialog.dialogData.docTypeId, payload)
    }

    return { type, credentials, v$, submit }
  },
}
</script>
